<template>
    <div id="wrapper">
        <SidebarView :term-transactions-reports="true" :operation="true" :operations-visible="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <TopbarView />
                <div class="container">
                    <div class="card card-shape home-box">
                        <div class="card-header">
                            <div class="row align-items-center">
                                <div class="col-6">
                                    <h6 class="m-0 fw-bold text-green">
                                        Fixed-Term Transactions Reports
                                    </h6>
                                </div>
                                <div class="col-6 text-end">
                                    <b-button @click="generateExcel"
                                        class="btn-sm ms-5 me-2 akkurate-green-btn akkurate-small">
                                        <font-awesome-icon :icon="['fas', 'file-excel']" />
                                    </b-button>
                                    <b-button class="me-2 btn-sm akkurate-green-btn akkurate-small" title="Filter"
                                        v-b-modal.modal-transaction>
                                        <span class="akkurate-small"><font-awesome-icon
                                                :icon="['fas', 'filter']" /></span>
                                    </b-button>
                                    <b-button @click="printPDF"
                                        class="me-2 btn-sm akkurate-green-btn akkurate-small"><font-awesome-icon
                                            :icon="['fas', 'print']" /></b-button>
                                    <b-button @click="downloadPDF"
                                        class="btn-sm akkurate-green-btn akkurate-small"><font-awesome-icon
                                            :icon="['fas', 'download']" /></b-button>
                                </div>
                            </div>
                        </div>

                        <b-modal size="lg" id="modal-transaction" @ok="handleOk">
                            <template #modal-title>
                                <h6 class="fw-bold mb-0 akkurate-green">Filter</h6>
                            </template>
                            <fixed-deposit-filter :form="form" :users="users"
                                :branch_option="branch_option"></fixed-deposit-filter>
                            <template #modal-footer="{ ok }">

                                <div class="w-100">
                                    <!-- Emulate built in modal footer ok and cancel button actions -->
                                    <b-button @click="$bvModal.hide('modal-transaction')" type="button"
                                        class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span
                                            class="small"><font-awesome-icon class="me-2"
                                                :icon="['fas', 'close']" />Cancel
                                        </span></b-button>
                                    <b-button @click="ok()" type="submit" :disabled="isSaving"
                                        class="akkurate-green-btn btn-size float-right border-0"><span
                                            class="small"><font-awesome-icon class="me-2"
                                                :icon="['fas', 'search']" />Search</span></b-button>
                                </div>
                            </template>
                        </b-modal>
                        <div class="card-body" ref="pdfContent">
                            <div class="row">
                                <div class="col-12 col-md-12">
                                    <statement-institution :institution="institution" :current_date="false"
                                        :title="getTitle"></statement-institution>
                                </div>
                                <hr />
                                <div class="col-6 row mb-2">
                                    <div class="col-12 small">
                                        Branch(es) : <span class="fw-bold">{{ branch_list }}</span>
                                    </div>
                                </div>

                                <div class="row col-6">
                                    <div class="col-md-12 col-12 text-end bd-highlight">
                                        <span class="mt-2"> From:
                                            <strong>{{ form.start_date }}</strong>
                                            To:
                                            <strong>{{ form.end_date }}</strong>
                                        </span>

                                    </div>
                                </div>
                            </div>
                            <div v-if="isLoading" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                            <div class="row">
                                <div class="trans_details">
                                    <b-table striped bordered responsive id="allAccountTable" :busy.sync="isLoading"
                                        :items="items" :fields="fields" :tbody-tr-class="rowClass" show-empty>
                                        <template #empty="scope">
                                            <h4 class="text-center small mt-3">{{ scope.emptyText }}</h4>
                                        </template>
                                        <template #table-busy>
                                            <div class="text-center text-danger my-2">
                                                <b-spinner class="align-middle"></b-spinner>
                                                <strong>Loading...</strong>
                                            </div>
                                        </template>
                                        <template #cell(index)="data">
                                            {{ data.index + 1 }}
                                        </template>

                                        <!-- A custom formatted column -->
                                        <template #cell(user)="data">
                                            {{ data.item.created_user?.first_name }} {{ data.item.created_user?.surname
                                            }}
                                        </template>
                                        <template #cell(full_name)="data">
                                            {{ data.item.customer?.last_name }} {{ data.item.customer?.first_name }}
                                        </template>
                                        <template #cell(trans_status)="data">
                                            <span :class="statusBadge(data.item.trans_status)">{{ data.item.trans_status
                                            }}</span>
                                        </template>
                                        <template #cell(trans_amount)="data">
                                            {{ institution.currency_code }} {{ displayNumber(data.item.trans_amount) }}
                                        </template>
                                        <template #cell(reference)="data">
                                            <div>TRA{{ data.item.id }}</div>
                                        </template>
                                        <template #cell(branch)="data">
                                            <div>{{ getBranch(data.item.account.branch_id) }}</div>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between px-3 pb-3">
                                <b-pagination class="mt-1" @change="navigatePage" v-model="currentPage"
                                    :total-rows="totalRecords" :per-page="perPage"
                                    aria-controls="member-table"></b-pagination>
                                <!-- <b-form-select @change="selectPerPage" v-model="per_page_selected" :options="per_page_options"
                        size="sm" class="mt-3"></b-form-select> -->
                                <div class="col text-end mt-1 akkurate-dark">
                                    <div>{{ currentPage }} - {{ perPage }} of {{ totalRecords }}</div>
                                    <b-form-group label="Per Page" label-size="sm" class="mb-0">
                                        <b-form-select @change="selectPerPage" id="per-page-select" v-model="perPage"
                                            :options="per_page_options" size="sm"></b-form-select>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer></footer>
        </div>

        <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
    </div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import html2pdf from "html2pdf.js";
import ReportFilter from "@/views/main/pages/reports/form/ReportFilter.vue";
import FixedDepositFilter from "../../investment/fixed-deposit/transactions/FixedDepositFilter.vue";
import ExcelJS from "exceljs";
import ChatBot from "@/views/components/AI/ChatBot.vue";
export default {
    components: {
        SidebarView,
        TopbarView,
        Footer,
        StatementInstitution,
        Multiselect,
        ReportFilter,
        FixedDepositFilter,
        ChatBot,
    },
    data() {
        return {
            filter: {
                branches: [],
                voucher_status: [],
            },
            ...this.initialState(),

            fields: [
                {
                    label: "Receipt_No",
                    key: "id",
                },

                {
                    label: "Code",
                    key: "account.fixed_deposit.code",
                },
                {
                    label: "References",
                    key: "reference",
                },
                {
                    label: "Customer_Name",
                    //key: 'customer.first_name',
                    key: 'full_name',
                    // title: this.getFullname,
                },
                {
                    label: "Amount",
                    key: "trans_amount",
                },
                {
                    label: "Account_No",
                    key: "account.account_number",
                },
                {
                    label: "Trans_Type",
                    key: "transaction_type",
                },
                {
                    label: "Trans_Mode",
                    key: "transaction_mode",
                },
                {
                    label: "Phone_No",
                    key: "customer.mobile",
                },
                {
                    label: "Status",
                    key: "trans_status",
                },
                {
                    label: "Date",
                    key: 'trans_date',
                    // key: this.getCreatedAt,
                },
                {
                    label: "Branch",
                    key: 'branch',
                    // key: this.getCreatedAt,
                },
                {
                    label: "Source",
                    key: "source",
                },
                {
                    label: "User",
                    key: "user",
                },
            ],
            items: [],
            start_date: "",
            end_date: "",
            branch_list: "",
            currentPage: 1,
            perPage: 10,
            per_page_options: ['10', '20', '50', '100', '500', 'All'],
            reverse_pemission: true,
            fd_scheme_option: [],
        };
    },
    mounted() {
        this.getAccountDropdown();
        this.getInsistution();
        this.loadTransactions();
    },
    methods: {
        statusBadge(item) {
            if (item === 'COMPLETED') {
                return 'badge akkurate-green-bg'
            } else if (item === 'FAILED') {
                return 'badge akkurate-danger-bg'
            } else if (item === 'REVERSED') {
                return 'badge akkurate-danger-bg'
            } else if (item === 'PENDING') {
                return 'badge akkurate-warning-bg'
            } else {
                return 'badge akkurate-warning-bg'
            }
        },
        getBranch(id) {
            if (!this.branch_option || this.branch_option.length === 0) {
                return 'N/A';
            }
            const b = this.branch_option.find(branch => branch.id === id);
            console.log(b)
            return b ? b.name : 'N/A';
        },
        submitFormFilters() {
            this.loadTransactions();
            this.coa_name = this.form.users.map(index => {
                return `${index.first_name} ${index.surname}`;
            }).join(', ');
        },
        rowClass() {
            return 'custom-row-height'
        },
        filterTable() {
            this.loadTransactions();
        },

        navigatePage(index) {
            this.isLoading = true;
            this.currentPage = index;
            this.loadTransactions()
        },
        selectPerPage(index) {
            this.perPage = index
            this.loadTransactions()
        },
        handleOk(bvModalEvent) {
            this.submitFormFilters()
        },
        async getAccountDropdown() {
            await ApiService.get("/investments/fixed-term-deposits/dropdown")
                .then((response) => {
                    // console.log(response);
                    this.branch_option = response.data.branches;
                    this.fd_scheme_option = response.data.fd_scheme;
                    this.users = response.data.users;

                    response.data.branches.forEach((branch, i) => {
                        this.branch_list = this.branch_list + (i != 0 ? ", " : "") + branch.name
                    });
                })
                .catch((error) => {
                    // console.log(error);
                });
        },

        async getInsistution() {
            await ApiService.get("/settings/institution")
                .then((response) => {
                    // console.log(response);
                    this.institution = response.data.data;
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        async loadTransactions(searchFilter = null) {
            this.isLoading = true;
            var branch_id = [];
            var acc_id = "";
            var product_id = "";
            if (this.form.branch != []) {
                branch_id = this.form.branch.map(index => index.id) ?? [];
            }
            if (this.form.acc_types != null) {
                acc_id = this.form.acc_types.id;
            }
            if (this.form.product != []) {
                product_id = this.form.product.map(index => index.id) ?? [];
            }

            this.$Progress.start();
            this.isLoading = true;
            let source = "";
            if (this.form?.trans_source?.value === "ussd" || this.form?.trans_source?.value === "web" || this.form?.trans_source?.value === "mobile") {
                source = this.form?.trans_source.value;
            }
            if (this.perPage === 'All') {
                this.perPage = this.totalRecords;
            }
            console.log(this.form)
            await ApiService.post("/investments/fixed-deposit-transactions", {
                page: this.currentPage,
                per_page: this.perPage,
                filter: this.form.search,
                branch_id: branch_id,
                account_type_id: acc_id,
                // account_number: ac,
                // mobile: phone,
                start_date: this.form.start_date,
                end_date: this.form.end_date,
                status: this.form.status,
                // code: code,
                transaction_type: this.form.transaction_type,
                external_reference: this.form.external_reference,
                source: source,
                users: this.form.users,
                product: product_id,
                term: this.form.term,
                transaction_mode: this.form.transaction_mode
            })
                .then((response) => {
                    this.items = response.data.data;

                    console.log("Data ", this.items)
                    this.total_complete_deposits = response.data.total_fd_deposit
                    this.total_complete_withdrawals = response.data.total_fd_withdrawal
                    this.totalRecords = response.data.meta.total;
                    // this.all_data = response.data.data;
                    this.$Progress.finish();
                })
                .catch((error) => {
                    // console.log(error);
                    this.isLoading = false;
                    this.$Progress.fail();
                })
                .finally(() => {
                    this.isLoading = false;
                    this.$Progress.finish();
                });
        },

        initialState() {
            return {
                totalRecords: 0,
                showViewTransaction: false,
                searchFilter: "",
                total_complete_deposits: "",
                total_complete_withdrawals: "",
                delete_trans: false,
                restore_trans: false,
                coa_name: "",
                form: {
                    branch: [],
                    acc_types: "",
                    start_date: this.getOneMonthEailer(),
                    end_date: new Date().toISOString().substr(0, 10),
                    status: "",
                    external_reference: "",
                    users: [],
                    status_option: ["Active", "Inactive", "Dormant", "Closed"],
                    search: "",
                    trans_source: {},
                    transaction_type: "",
                    product: [],
                    term: "",
                    transaction_mode: [],
                    loan_status:[],
                },
                branch_option: [],
                acc_types_option: [],
                isLoading: true,
                isSaving: false,
                add_or_edit: "add",
                report_data: {},
                institution: {},
                users: [],
            };
        },
        // getFullname(trans) {
        //   return `${trans.customer?.first_name} ${trans.customer?.last_name}`;
        // },
        getCreatedAt(trans) {
            return this.removeAfterDot(trans.created_at);
        },
        fullName({ first_name, surname, code }) {
            let name = ""
            if (first_name) {
                name = name + first_name;
            }
            if (surname) {
                name = name + " " + surname;
            }
            return `${name}`
        },
        downloadPDF() {
            const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
            // console.log("here");
            const pdfOptions = {
                margin: [2, 2, 2, 2], //top, left, buttom, right
                filename: "statement.pdf",
                image: { type: "jpg", quality: 6 },
                html2canvas: { scale: 2 },

                jsPDF: {
                    unit: "mm",
                    format: "A4",
                    orientation: "landscape",
                },
            };
            html2pdf()
                .from(content)
                .set(pdfOptions)
                .toPdf()
                .get("pdf")
                .then((pdf) => {
                    var totalPages = pdf.internal.getNumberOfPages();
                    var insit_name = this.institution.name;
                    var insit_tele = this.institution.telephone;
                    var insit_email = this.institution.email;
                    var insit_motto = this.institution.motto;

                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(8);
                        pdf.setTextColor(150);
                        pdf.text(
                            [
                                "For Inquiries, Please Contact " +
                                insit_name +
                                ", Customer Service on " +
                                insit_tele +
                                "",
                                "or email us on " +
                                insit_email +
                                " " +
                                insit_motto +
                                "",
                                "Page " + i + " of " + totalPages,
                            ],
                            pdf.internal.pageSize.getWidth() / 2,
                            pdf.internal.pageSize.getHeight() - 0.6,
                            { align: "center" }
                        );
                    }
                })
                .save();
        },
        printPDF() {
            const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
            console.log(content)
            // console.log("here");
            const pdfOptions = {
                margin: 2, //top, left, buttom, right
                filename: "statement.pdf",
                image: { type: "jpg", quality: 6 },
                html2canvas: { scale: 2 },

                jsPDF: {
                    unit: "mm",
                    format: "A4",
                    orientation: "landscape",
                },
            };
            html2pdf()
                .from(content)
                .set(pdfOptions)
                .toPdf()
                .get("pdf")
                .then((pdf) => {
                    var totalPages = pdf.internal.getNumberOfPages();
                    var insit_name = this.institution.name;
                    var insit_tele = this.institution.telephone;
                    var insit_email = this.institution.email;
                    var insit_motto = this.institution.motto;
                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(8);
                        pdf.setTextColor(150);
                        pdf.text(
                            [
                                "For Inquiries, Please Contact " +
                                insit_name +
                                ", Customer Service on " +
                                insit_tele +
                                "",
                                "or email us on " +
                                insit_email +
                                " " +
                                insit_motto +
                                "",
                                "Page " + i + " of " + totalPages,
                            ],
                            pdf.internal.pageSize.getWidth() / 2,
                            pdf.internal.pageSize.getHeight() - 0.6,
                            { align: "center" }
                        );
                    }
                    // Get the blob of the PDF
                    return pdf.output("blob");
                })
                .then((pdfBlob) => {
                    // Create a URL for the PDF blob
                    var pdfUrl = URL.createObjectURL(pdfBlob);

                    // Open the URL in a new tab
                    const printWindow = window.open(
                        pdfUrl,
                        "_blank",
                        "width=800,height=600"
                    );
                    printWindow.onload = () => {
                        printWindow.print();
                        URL.revokeObjectURL(pdfUrl);
                    };
                })
                .catch((error) => {
                    console.error("Error generating PDF:", error);
                });
        },
        filterAction() {
            this.getVoucherListing();
            console.log(this.form);
            // this.changePerPageNumber(this.perPage);
            // this.form.start_date =
            // this.getBalanceSheets();
        },
        async generateExcel() {
            const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx";
            const imageUrl = "/default_logo.png";

            const institutionName = this.institution.name || '';
            const institutionMotto = this.institution.motto || '';
            const institutionAddress = this.institution.address || '';
            const institutionPhone = this.institution.telephone || '';
            const institutionEmail = this.institution.email || '';
            const dateRange = `FROM: ${this.form.start_date} TO: ${this.form.end_date}`;
            const branchList = this.branch_list || 'All Branches';

            try {
                // Load the Excel template
                const response = await fetch(fileUrl);
                if (!response.ok) throw new Error(`Network response was not ok: ${response.statusText}`);
                const arrayBuffer = await response.arrayBuffer();

                const wb = new ExcelJS.Workbook();
                await wb.xlsx.load(arrayBuffer);
                const ws = wb.getWorksheet(1);

                // Add institution logo if available
                try {
                    const imageResponse = await fetch(imageUrl);
                    if (imageResponse.ok) {
                        const imageBuffer = await imageResponse.arrayBuffer();
                        const imageId = wb.addImage({ buffer: imageBuffer, extension: "png" });
                        ws.addImage(imageId, { tl: { col: 0, row: 0 }, ext: { width: 300, height: 200 } });
                    }
                } catch (imageError) {
                    console.warn("Could not load image:", imageError);
                }

                // Add institution details
                const startRow = 1;
                ws.getCell(`L${startRow}`).value = institutionName;
                ws.getCell(`L${startRow}`).font = { bold: true, size: 14 };
                ws.getCell(`L${startRow + 1}`).value = institutionAddress;
                ws.getCell(`L${startRow + 1}`).font = { size: 12 };
                ws.getCell(`L${startRow + 2}`).value = institutionMotto;
                ws.getCell(`L${startRow + 2}`).font = { size: 12 };
                ws.getCell(`L${startRow + 3}`).value = institutionPhone;
                ws.getCell(`L${startRow + 3}`).font = { size: 12 };
                ws.getCell(`L${startRow + 4}`).value = institutionEmail;
                ws.getCell(`L${startRow + 4}`).font = { size: 12 };
                ws.getCell(`L${startRow + 6}`).value = dateRange;
                ws.getCell(`L${startRow + 6}`).font = { size: 12 };
                ws.getCell(`L${startRow + 7}`).value = `Branch(es): ${branchList}`;
                ws.getCell(`L${startRow + 7}`).font = { size: 12 };
                ws.getColumn("L").width = 50;

                // Add headers for the fixed deposit transactions table
                const headerRowNum = 13;
                const headerRow = ws.getRow(headerRowNum);
                headerRow.values = [
                    "Receipt No",
                    "Code",
                    "References",
                    "Customer Name",
                    "Amount",
                    "Account No",
                    "Trans Type",
                    "Trans Mode",
                    "Phone No",
                    "Status",
                    "Date",
                    "Branch",
                    "Source",
                    "User"
                ];
                headerRow.font = { bold: true };
                headerRow.alignment = { horizontal: "center" };
                headerRow.commit();

                let currentRowNum = headerRowNum + 1;

                // Loop through transaction items and add rows
                for (const item of this.items) {
                    const row = ws.getRow(currentRowNum);

                    row.getCell(1).value = item.id || '';
                    row.getCell(2).value = item.account?.fixed_deposit?.code || '';
                    row.getCell(3).value = `TRA${item.id}` || '';
                    row.getCell(4).value = `${item.customer?.last_name || ''} ${item.customer?.first_name || ''}`;
                    row.getCell(5).value = Number(item.trans_amount || 0);
                    row.getCell(6).value = item.account?.account_number || '';
                    row.getCell(7).value = item.transaction_type || '';
                    row.getCell(8).value = item.transaction_mode || '';
                    row.getCell(9).value = item.customer?.mobile || '';
                    row.getCell(10).value = item.trans_status || '';
                    row.getCell(11).value = item.trans_date || '';
                    row.getCell(12).value = this.getBranch(item.account?.branch_id) || '';
                    row.getCell(13).value = item.source || '';
                    row.getCell(14).value = `${item.created_user?.first_name || ''} ${item.created_user?.surname || ''}`;

                    row.commit();
                    currentRowNum++;
                }

                // Set column widths for better readability
                ws.getColumn(1).width = 12;  // Receipt No
                ws.getColumn(2).width = 15;  // Code
                ws.getColumn(3).width = 15;  // References
                ws.getColumn(4).width = 25;  // Customer Name
                ws.getColumn(5).width = 15;  // Amount
                ws.getColumn(6).width = 18;  // Account No
                ws.getColumn(7).width = 15;  // Trans Type
                ws.getColumn(8).width = 15;  // Trans Mode
                ws.getColumn(9).width = 15;  // Phone No
                ws.getColumn(10).width = 12; // Status
                ws.getColumn(11).width = 18; // Date
                ws.getColumn(12).width = 20; // Branch
                ws.getColumn(13).width = 12; // Source
                ws.getColumn(14).width = 20; // User

                // Generate and download Excel file
                const buffer = await wb.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = `Fixed_Term_Transactions_Report_${new Date().toISOString().slice(0, 10)}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(link.href);

            } catch (err) {
                console.error("Error generating Excel file:", err);
                this.$bvToast.toast('Failed to generate Excel file. Please try again.', {
                    title: 'Export Error',
                    variant: 'danger',
                    solid: true
                });
            }
        }
    },
    computed: {
        getTitle() {
            let title = 'Fixed-Term Deposit Reports';
            if (this.filter.status) {
                title += ` - ${this.filter.status}`;
            }
            // if (this.filter.branch) {
            //     title += ` - ${this.filter.branch}`;
            // }
            // if (this.filter.trans_source) {
            //     title += ` - ${this.filter.trans_source.name}`;
            // }
            // if (this.start_date && this.end_date) {
            //     title += ` from ${this.start_date} to ${this.end_date}`;
            // }
            return title;
        },
    }
};
</script>